module.exports = __webpack_public_path__ + "img/oaks-nest-nook-3.c5d72af3.jpeg";